import {fromJS} from 'immutable'

import {getListIndexById} from 'utils/helpers'

export const curriculumState = fromJS({
  id: 0,
  code: '',
  name: '',
  is_active: true,
})

export const curriculumSubjectState = fromJS({
  id: 0,
  year: '',
  sem: '',
  code: '',
  name: '',
  is_active: true,
  is_in_gpa: true,
  lec_units: '',
  lab_units: '',
  units: '',
  lec_hrs: '',
  lab_hrs: '',
  hours: '',
  funits: '',
  punits: '',
  lab_type: 'L',
  prereq: [],
  coreq: [],
  standing: '0',
})

const initialState = fromJS({
  list: [], // search results
  item: {}, // holds one curriculum object
  items: {}, // holds curriculumID with subjects
  pending: false,
})

export default function curriculum(state = initialState, action) {
  switch (action.type) {
    case 'CUR_REQ':
    case 'CURSUB_REQ':
      return state.set('pending', true)

    case 'CUR_Q_SUCC':
      return state
        .set('pending', false)
        .set('list', fromJS(action.payload || []))

    case 'CUR_SAVE_SUCC':
    case 'CUR_GET_SUCC': {
      // update search result if present
      let list = state.get('list')
      const index = getListIndexById(action.payload.id, list)
      if (index !== -1) {
        list = list.set(index, fromJS(action.payload))
      }
      return state
        .set('pending', false)
        .set('item', fromJS(action.payload))
        .set('list', list)
    }

    case 'CUR_DEL_SUCC': {
      // delete search results if present
      const index = getListIndexById(Number(action.payload), state.get('list'))
      if (index === -1) {
        return state.set('pending', false)
      }
      return state
        .set('pending', false)
        .set('list', state.get('list').remove(index))
    }

    case 'CURSUB_GET_SUCC':
    case 'CURSUB_SAVE_SUCC':
    case 'CURSUB_DEL_SUCC':
      return state
        .set('pending', false)
        .setIn(['items', action.meta.curriculumID], fromJS(action.payload))

    case 'NOTIF_FAIL':
      return state.set('pending', false)

    default:
      return state
  }
}



// WEBPACK FOOTER //
// ./src/containers/Manage/Curriculums/reducer.js